import { Input } from "reactstrap";
import { AsyncPaginatedSelect } from "components/common/AsyncPaginatedSelect";
import { getClientOptions } from "features/Clients/services/ClientService";
import {
  QuotationSourceLabelMap,
  QuotationSourceType,
  QuotationStatus,
  QuotationStatusMap,
} from "features/Quotations/constants/quotation.constants";
import type { SelectOption } from "types/api.types";

export type QuotationListFiltersProps = {
  status: string;
  onStatusChange: (value: string) => void;
  sourceType: string;
  onSourceTypeChange: (value: string) => void;
  clientId: number | null;
  onClientIdChange: (value: number | null) => void;
};

export default function QuotationListFilters({
  status,
  onStatusChange,
  sourceType,
  onSourceTypeChange,
  clientId,
  onClientIdChange,
}: QuotationListFiltersProps) {
  return (
    <div className="d-flex align-items-center gap-2 flex-wrap">
      <Input
        type="select"
        className="form-select form-select-sm"
        style={{ width: 150 }}
        value={status}
        onChange={(e) => onStatusChange(e.target.value)}
      >
        <option value="">All statuses</option>
        {(Object.values(QuotationStatus) as QuotationStatus[]).map((s) => (
          <option key={s} value={s}>
            {QuotationStatusMap[s]?.label ?? s}
          </option>
        ))}
      </Input>
      <Input
        type="select"
        className="form-select form-select-sm"
        style={{ width: 160 }}
        value={sourceType}
        onChange={(e) => onSourceTypeChange(e.target.value)}
      >
        <option value="">All sources</option>
        {(Object.values(QuotationSourceType) as QuotationSourceType[]).map(
          (t) => (
            <option key={t} value={t}>
              {QuotationSourceLabelMap[t] ?? t}
            </option>
          ),
        )}
      </Input>
      <div style={{ width: 200 }}>
        <AsyncPaginatedSelect
          fetchOptions={getClientOptions}
          placeholder="Client…"
          value={clientId}
          onChange={(opt) =>
            onClientIdChange(
              opt && !Array.isArray(opt)
                ? Number((opt as SelectOption).value)
                : null,
            )
          }
        />
      </div>
    </div>
  );
}
